
import { CategoryWithCompetitions } from '@core/models/struct/CategoryWithCompetitions';

import { CategoryWithCompetitionsDto } from './dtos/CategoryWithCompetitionsDto';
import { getConfig } from '@superbet-group/web.lib.config';

export function transformCategoryWithCompetitions(dto: CategoryWithCompetitionsDto): CategoryWithCompetitions {
    const locale = getConfig().appLocale.locale;

    return {
        sportId: dto.sportId,
        categoryId: dto.categoryId,
        name: dto.localNames[locale]!,
        competitions: dto.competitions.map((competitionDto) => ({
            tournamentId: competitionDto.tournamentId,
            name: competitionDto.localNames[locale]!,
        })),
    };
}
